//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import { searchElements } from '@motionelements/core/src/api/search.js';

export default {
  name: 'product-recommendations-full-width',
  components: {
    Collections: () => import('@motionelements/catalog/src/modules/product/sections/recommendations/Collections.vue'),
    ProductsRecommendations: () => import('@motionelements/catalog/src/modules/product/sections/recommendations/ProductRecommendations.vue'),
    ProductCardStemsList: () => import('@motionelements/catalog/src/modules/product/sections/recommendations/ProductCardStemsList'),
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  mixins: [featureFlagMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    showStems: {
      type: Boolean,
      default: true,
    },
    isProduct2025: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      page: 1,
      perPage: 20,
      activeTab: null,
      recommendations: {
        sameArtist: 0,
        similar: 0,
        // sameCategory: [],
        samePlugin: 0,
      },
    };
  },
  computed: {
    ...mapState({
      elementArtistCollections: state => state.product.elementArtistDataCollections || [],
    }),
    hasRecommendations() {
      return !!this.activeTab;
    },
    recommendPlugin() {
      try {
        if (this.product.mediaType === 'ae_template') {
          const plugins = _.get(this.product, 'mediaTypeDetails.pluginsRequired');

          if (plugins && plugins.length) {
            // look for Element 3D

            const plugin = plugins.find(x => x.code.toLowerCase() === 'videocopilot_3darray');

            if (plugin) {
              return plugin;
            }
          }
        }
      } catch (e) {
        // eat errors
        console.error(e);
      }
      return null;
    },
    hasCollections() {
      return this.elementArtistCollections.length > 0;
    },
    hasStems() {
      return this.isFeatureEnabled('audio_stems') && this.product.stem;
    },
    //
    defaultActiveTab() {
      return isProductType('audio', this.product.mediaType) ? 'sameArtist' : 'similar';
    },
  },
  // watch: {
  //   product: {
  //     handler() {
  //       this.activeTab = this.defaultActiveTab;
  //       this.resetRecommendations();
  //       this.initRecommendations()
  //         .then(() => {
  //           // this.activeTab = Object.keys(this.recommendations).find(key => this.recommendations[key] > 0);
  //         })
  //         .finally(() => {
  //           this.loading = false;
  //         });
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    this.activeTab = this.defaultActiveTab;
    this.$bus.$on('ProductRecommendations:change-tab', (tab) => {
      this.changeTab(tab);
    });
    this.initRecommendations()
      .then(() => {
        // this.activeTab = Object.keys(this.recommendations).find(key => this.recommendations[key] > 0);
        if (!this.activeTab && this.hasCollections) {
          this.activeTab = 'collections';
        }
        if (!this.activeTab && this.hasStems) {
          this.activeTab = 'stems';
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    changeTab(recommendType) {
      this.activeTab = recommendType;
    },
    getSameArtistRecommendations() {
      return searchElements(this.product.mediaType, {
        perPage: this.perPage,
        page: this.page,
        artist: this.product.artist.username,
      })
        .then(({ data: { data } }) => {
          this.recommendations.sameArtist = data.length;
        })
        .catch(error => console.error(error.message));
    },
    getSimilarRecommendations() {
      return searchElements(this.product.mediaType, {
        perPage: this.perPage,
        page: this.page,
        similar: this.product.id,
      })
        .then(({ data: { data } }) => {
          this.recommendations.similar = data.length;
        })
        .catch(error => console.error(error.message));
    },
    getPluginsRecommendations() {
      if (this.recommendPlugin) {
        return searchElements(this.product.mediaType, {
          perPage: this.perPage,
          page: this.page,
          plugin: this.recommendPlugin.code.toLowerCase(),
        })
          .then(({ data: { data } }) => {
            this.recommendations.samePlugin = data.length;
          })
          .catch(error => console.error(error.message));
      }
    },
    initRecommendations() {
      console.log('initRecommendations');
      this.loading = true;
      return Promise.all([
        // this.getSameArtistRecommendations(),
        // this.getSimilarRecommendations(),
        this.getPluginsRecommendations(),
      ]);
    },
    resetRecommendations() {
      Object.keys(this.recommendations).forEach(key => {
        this.recommendations[key] = 0;
      });
    },
  },
};
